import React from 'react';
import { withRouter } from "react-router-dom";

import './Bg.scss';
// import SocialLinks from '../../../components/SocialLinks';


// const socialObg = [
//   {
//     id: 1,
//     name: 'facebook',
//     icon: 'ion-social-facebook'
//   },
//   {
//     id: 2,
//     name: 'twitter',
//     icon: 'ion-social-twitter'
//   },
//   {
//     id: 3,
//     name: 'youtube',
//     icon: 'ion-social-youtube'
//   }
// ];

const Bg = () => {
  return (

    <div className="bg">
      <div className="bg__item bg__item_text">
        <div className="bg__body not-font">1</div>
        <p className="margin not-font">1</p>
        <p className="bg__text">adventure</p>
        <p className="margin not-font">1</p>
        <div className="bg__body not-font">1</div>
      </div>
      <div className="bg__item hide">
        <div className="bg__body not-font">1</div>
      </div>
      <div className="bg__item">
        <div className="bg__body not-font">1</div>
      </div>
      <div className="bg__item">
        <div className="bg__body not-font">1</div>
      </div>
      <div className="bg__item bg__item_groups">
        <div className="bg__body not-font">1</div>
        <p className="margin not-font">1</p>
        {/* <ul className="social-link"> */}
        {/* <SocialLinks */}
        {/* className="button__icon ion-social-facebook" */}
        {/* name="facebook" */}
        {/* /> */}
        {/* <SocialLinks */}
        {/* className="button__icon ion-social-twitter" */}
        {/* name="twitter" */}
        {/* /> */}
        {/* <SocialLinks */}
        {/* className="button__icon ion-social-youtube" */}
        {/* name="youtube" */}
        {/* /> */}
        {/* </ul> */}

        {/* <p className="margin not-font">1</p> */}
        {/* <div className="bg__body not-font bg__body-center">1</div> */}
        {/* <p className="margin not-font">1</p> */}
        <p className="bg__text">follow us</p>
        <p className="margin not-font">1</p>
        <div className="bg__body not-font">1</div>
      </div>
    </div>
  )
};

export default withRouter(Bg);


// WEBPACK FOOTER //
// ./src/app/containers/Main/components/Bg.js